import { useQuery } from '@tanstack/react-query';

import { getLocale } from '../../../shared/i18n';
import {
  fetchHealthInformationCmsPage,
  healthInformationCmsQueryKey,
  type HealthInformationAppLanguage,
} from './healthInformationCms';

function resolveAppLanguage(): HealthInformationAppLanguage {
  return getLocale() === 'ar' ? 'ar' : 'en';
}

export function useHealthInformationCmsQuery() {
  const language = resolveAppLanguage();
  return useQuery({
    queryKey: [...healthInformationCmsQueryKey, language],
    queryFn: () => fetchHealthInformationCmsPage(language),
    staleTime: 5 * 60 * 1000,
  });
}
